import { useAppDispatch } from 'state'
import { useCallback } from 'react'
import { fetchNftPoolFarmDataAsync, fetchV2SwapAprsAsync } from 'state/xFarms'
import { FarmsPageLayout, FarmsContext } from 'views/xFarms'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useNftPools from 'views/xFarms/hooks/useNftPools'
import { getNftPoolConfigs } from 'config/constants/farms'
import React, { useContext, useEffect, useState } from 'react'
import PaginationControls from 'components/PaginationControls'
import dynamic from 'next/dynamic'

const NFTPoolCardTable = dynamic(() => import('views/xFarms/components/FarmTable/NFTPoolCardTable'), { ssr: true })

function CategoryWrapper({ title, children }) {
  return <>{children}</>
}

const farmcategories = [
  {
    title: 'Baseswap',
    pids: [
      9001, 9002, 9003, 9004, 9005, 1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 24, 21, 22, 23,
      24, 25, 26, 27, 28, 34, 35, 36, 37, 38,
    ],
  },
]

const XFarmPage = () => {
  const { account, chainId, library: provider } = useActiveWeb3React()
  const [farmOpen, setFarmOpen] = useState<string>('')

  const dispatch = useAppDispatch()
  const { chosenFarmsMemoized, viewMode, stakedOnlyState } = useContext(FarmsContext)

  const categorizedFarms = farmcategories.map((category) => {
    const farms = chosenFarmsMemoized.filter((farm) => category.pids.includes(farm.pid))
    return { ...category, farms }
  })

  const { fetchUserXFarmData } = useNftPools()

  useEffect(() => {
    const farmConfigs = getNftPoolConfigs(chainId)
    dispatch(fetchV2SwapAprsAsync({ chainId }))
    if (chainId && account) {
      fetchUserXFarmData()
      dispatch(fetchNftPoolFarmDataAsync({ chainId, farmConfigs, provider }))
    } else if (chainId) {
      dispatch(fetchNftPoolFarmDataAsync({ chainId, farmConfigs, provider }))
    }

    const interval = setInterval(() => {
      if (chainId) {
        dispatch(fetchNftPoolFarmDataAsync({ chainId, farmConfigs, provider }))
      }
    }, 30000)

    return () => {
      if (interval) clearInterval(interval)
    }
  }, [chainId, dispatch, account])

  const [currentPage, setCurrentPage] = useState(1)
  const PAGE_SIZE = 8
  const onPageChange = useCallback((page) => {
    setCurrentPage(page)
  }, [])

  return (
    <>
      {categorizedFarms.map(({ title, farms }, i) => {
        const totalPages = Math.ceil(farms.length / PAGE_SIZE)
        const indexOfLastFarm = currentPage * PAGE_SIZE
        const indexOfFirstFarm = indexOfLastFarm - PAGE_SIZE
        const currentFarms = stakedOnlyState ? farms : farms.slice(indexOfFirstFarm, indexOfLastFarm)
        return (
          <CategoryWrapper title={title} key={`${title}-${i}`}>
            {viewMode === 'TABLE' &&
              currentFarms.map((farm, i) => {
                return (
                  <NFTPoolCardTable
                    key={farm.pid}
                    farm={farm}
                    removed={false}
                    stakedOnly={stakedOnlyState}
                    setFarmOpen={setFarmOpen}
                    farmOpen={farmOpen}
                  />
                )
              })}
          </CategoryWrapper>
        )
      })}
      {!stakedOnlyState && (
        <PaginationControls
          currentPage={currentPage}
          totalPages={Math.ceil(chosenFarmsMemoized.length / PAGE_SIZE)}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </>
  )
}

XFarmPage.Layout = FarmsPageLayout

export default XFarmPage
